/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiMenuShapeSquare9Icon16Light } from './UiMenuShapeSquare9Icon16Light';
import { UiMenuShapeSquare9Icon16Regular } from './UiMenuShapeSquare9Icon16Regular';
import { UiMenuShapeSquare9Icon16Solid } from './UiMenuShapeSquare9Icon16Solid';
import { UiMenuShapeSquare9Icon20Light } from './UiMenuShapeSquare9Icon20Light';
import { UiMenuShapeSquare9Icon20Regular } from './UiMenuShapeSquare9Icon20Regular';
import { UiMenuShapeSquare9Icon20Solid } from './UiMenuShapeSquare9Icon20Solid';
import { UiMenuShapeSquare9Icon24Regular } from './UiMenuShapeSquare9Icon24Regular';
import { UiMenuShapeSquare9Icon24Solid } from './UiMenuShapeSquare9Icon24Solid';
import { UiMenuShapeSquare9Icon32Regular } from './UiMenuShapeSquare9Icon32Regular';
import { UiMenuShapeSquare9Icon64Regular } from './UiMenuShapeSquare9Icon64Regular';
var sizes = {
    16: {
        light: UiMenuShapeSquare9Icon16Light,
        regular: UiMenuShapeSquare9Icon16Regular,
        solid: UiMenuShapeSquare9Icon16Solid,
    },
    20: {
        light: UiMenuShapeSquare9Icon20Light,
        regular: UiMenuShapeSquare9Icon20Regular,
        solid: UiMenuShapeSquare9Icon20Solid,
    },
    24: {
        regular: UiMenuShapeSquare9Icon24Regular,
        solid: UiMenuShapeSquare9Icon24Solid,
    },
    32: {
        regular: UiMenuShapeSquare9Icon32Regular,
    },
    64: {
        regular: UiMenuShapeSquare9Icon64Regular,
    },
};
export var UiMenuShapeSquare9Icon = forwardRef('UiMenuShapeSquare9Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
